import Vue from 'vue'
import axios from 'axios'
import RegistrarTienda from '@src/registro/registrar_tienda'

// force full height & purple background
window.addEventListener('load', () => {
  document.documentElement.style.height = '100%'
  document.documentElement.style.backgroundColor = '#563ea0'
  document.body.style.minHeight = '100vh'

  new Vue({
    el: '#loader',

    created() {
      let csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
      axios.defaults.headers.common['X-CSRF-Token'] = csrfToken
    },

    render(h) {
      return h(RegistrarTienda)
    }
  })
})
